/* Sticky add to cart on the product page (sections/main-product.liquid).
   Shown once the Buy buttons block is above the window (or behind the header), hidden again when it comes back.
   While hidden the bar is inert, so it is neither tabbable nor read out. The bar is re-rendered
   with the section on a variant change; connectedCallback sets it up again from scratch. */

class MwStickyCart extends HTMLElement {
  connectedCallback() {
    const buy = this.closest('.pdp')?.querySelector('.pdp-buy');
    if (!buy) return;
    // Measured on scroll rather than observed: an observer only reports crossings, so a jump
    // straight past the buttons (an anchor link to the reviews, a restored scroll position)
    // went unnoticed and the bar stayed hidden. Anything behind the sticky header counts as out
    // of view, as it is for the shopper.
    this.buy = buy;
    this.check = () => {
      this.frame = 0;
      const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-offset')) || 0;
      const past = this.buy.getBoundingClientRect().bottom < header;
      if (past === this.past) return;
      this.past = past;
      this.classList.toggle('is-shown', past);
      this.inert = !past;
    };
    this.onScroll = () => {
      if (!this.frame) this.frame = requestAnimationFrame(this.check);
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.past = null;
    this.check();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    if (this.frame) cancelAnimationFrame(this.frame);
  }
}

if (!customElements.get('mw-sticky-cart')) customElements.define('mw-sticky-cart', MwStickyCart);

/* The bar's variant select sets the main picker's choices and lets the picker do the rest. */
document.addEventListener('change', (event) => {
  const select = event.target.closest?.('[data-sticky-variant]');
  if (!select) return;
  const values = (select.selectedOptions[0]?.dataset.options || '').split('¦');
  const picker = select.closest('[data-variant-root]')?.querySelector('mw-variant-picker');
  if (!picker) return;
  let last = null;
  values.forEach((value, index) => {
    const position = index + 1;
    const radio = [...picker.querySelectorAll(`input[type="radio"][data-option-position="${position}"]`)].find(
      (input) => input.value === value
    );
    if (radio && !radio.checked) {
      radio.checked = true;
      last = radio;
    }
    const dropdown = picker.querySelector(`select[data-option-position="${position}"]`);
    if (dropdown && dropdown.value !== value) {
      dropdown.value = value;
      last = dropdown;
    }
  });
  last?.dispatchEvent(new Event('change', { bubbles: true }));
});
